<app-sidenav>
  <ng-template #sidenavContent>
    <app-services-side-cards [companyName]="companyName"></app-services-side-cards>
  </ng-template>
  <ng-template #mainContent>
    <h1 class="content-main-title">{{ 'content.transunion-consumer-solutions' | translate }}</h1>
    <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>

    <mat-horizontal-stepper #stepper [linear]="true">
      <mat-step #step1 [completed]="false">
        <ng-template matStepLabel>{{ 'content.info-about-order' | translate }}</ng-template>
        <form [formGroup]="orderInformationForm" [ngClass]="{'form-submitted': orderInformationFormSubmitted}" (submit)="submitOrderInformation()" #formElement>
          <div class="row">
            <div class="form-group col-md-6 col-sm-12 pe-2">
              <label for="branchName">{{ 'content.branch-name' | translate }} *
                <select id="branchName" class="form-select" formControlName="branchName" #branchNameInput>
                  <option selected value="">{{ 'content.select-one' | translate }}</option>
                  @for (branchName of branchNames; track branchName) {
                    <option value="{{ branchName }}">{{ branchName }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="orderInformationFormSubmitted" [errors]="c.branchName.errors" [element]="branchNameInput"></app-validation-errors>
            </div>
            @if (isIfsRequest) {
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label for="selectProduct">{{ 'content.select-product' | translate }} *
                  <select id="selectProduct" class="form-select" formControlName="ifsProduct" #ifsProductInput>
                    <option selected value="">{{ 'content.select-one' | translate }}</option>
                    @for (ifsProduct of (ifsProducts | keyvalue); track ifsProduct) {
                      <option value="{{ ifsProduct.key }}">{{ ifsProduct.value }}</option>
                    }
                  </select>
                </label>
                <app-validation-errors [displayErrors]="orderInformationFormSubmitted" [errors]="c.ifsProduct.errors" [element]="ifsProductInput"></app-validation-errors>
              </div>
            }
            @if (!isIfsRequest) {
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label for="inquiryType">{{ 'content.inquiry-type' | translate }} *
                  <select id="inquiryType" class="form-select" formControlName="inquiryType" #inquiryTypeInput>
                    <option selected value="">{{ 'content.select-one' | translate }}</option>
                    @for (inquiryType of (inquiryTypes | keyvalue); track inquiryType) {
                      <option value="{{ inquiryType.key }}">{{ inquiryType.value }}</option>
                    }
                  </select>
                </label>
                <app-validation-errors [displayErrors]="orderInformationFormSubmitted" [errors]="c.inquiryType.errors" [element]="inquiryTypeInput"></app-validation-errors>
              </div>
            }
          </div>
          <div class="row">
            <div class="form-group col-md-6 col-sm-12">
              <label>{{ 'content.reference-id' | translate }} *
                <input class="form-control" type="text" autocomplete="on" formControlName="referenceId" #referenceIdInput>
              </label>
              <app-validation-errors [displayErrors]="orderInformationFormSubmitted" [errors]="c.referenceId.errors" [element]="referenceIdInput"></app-validation-errors>
            </div>
          </div>
          <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
            <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
            <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
          </div>
        </form>
      </mat-step>
      <mat-step #step2 [completed]="false">
        <ng-template matStepLabel>{{ 'content.primary-subject' | translate }}</ng-template>
        @if (currentProductType ==='consumer') {
          <app-consumer-subject-form [isIdx]="isIdxRequest" (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-consumer-subject-form>
        }
        @if (currentProductType ==='aml' || currentProductType ==='ebvsid') {
          <app-aml-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-aml-subject-form>
        }
        @if (currentProductType ==='eAml') {
          <app-eaml-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-eaml-subject-form>
        }
        @if (currentProductType ==='avs') {
          <app-avs-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-avs-subject-form>
        }
        @if (currentProductType ==='bvs') {
          <app-bvs-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-bvs-subject-form>
        }
        @if (currentProductType ==='dirs') {
          <app-dirs-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-dirs-subject-form>
        }
        @if (currentProductType ==='eDirs') {
          <app-edirs-subject-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-edirs-subject-form>
        }
        @if (currentProductType ==='dirsLookup') {
          <app-dirs-lookup-form (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-dirs-lookup-form>
        }
        @if (currentProductType ==='hawk') {
          <app-hawk-form [types]="hawkTypes" (back)="back()" (submittedData)="submitPrimarySubjectInfo($event)"></app-hawk-form>
        }
      </mat-step>
      @if (isJointType()) {
        <mat-step #step3 [completed]="false">
          <ng-template matStepLabel>{{ 'content.secondary-subject' | translate }}</ng-template>
          <app-consumer-subject-form [isIdx]="isIdxRequest" (back)="back()" (submittedData)="submitSecondarySubjectInfo($event)"></app-consumer-subject-form>
        </mat-step>
      }
      <mat-step #step4 [completed]="false">
        <ng-template matStepLabel>{{ 'content.review' | translate }}</ng-template>
        <div><p class="mt-0 mb-0">{{ 'content.order-form-please-verify-info' | translate }}</p></div>
        <div class="pt-2 pb-4">
          <h2 class="pt-2">{{ 'content.info-about-order' | translate }}</h2>
          <div class="row">
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.branch-name' | translate }}:</p></div>
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.branchName }}</p></div>
            @if (!isIfsRequest) {
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.inquiry-type' | translate }}:</p></div>
            }
            @if (!isIfsRequest) {
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ inquiryTypes[v.inquiryType] }}</p></div>
            }
            @if (isIfsRequest) {
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.product' | translate }}:</p></div>
            }
            @if (isIfsRequest && ifsProducts) {
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ ifsProducts[v.ifsProduct] }}</p></div>
            }
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.reference-id' | translate }}:</p></div>
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.referenceId }}</p></div>
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.report-language' | translate }}:</p></div>
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ i18nService.getTranslation('api.lang.full') | async }}</p></div>
          </div>
          @if (!!primarySubjectData) {
            <div>
              <h2 class="pt-3">{{ 'content.info-primary-subject' | translate }}</h2>
              <ng-container *ngTemplateOutlet='subject; context:{subject: primarySubjectData}'></ng-container>
            </div>
          }
          @if (!!secondarySubjectData) {
            <div>
              <h2 class="pt-3">{{ 'content.info-secondary-subject' | translate }}</h2>
              <ng-container *ngTemplateOutlet='subject; context:{subject: secondarySubjectData}'></ng-container>
            </div>
          }
        </div>
        <div class="review-footer">
          {{ 'content.order-form-review-footer' | translate }}
        </div>

        <ng-template #subject let-subject='subject'>
          @if (subject.firstName || subject.middleName || subject.lastName) {
            <div class="row">
              <h3 class="col-md-12 pt-1">{{ 'content.person.name' | translate }}</h3>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.first-name' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.firstName }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.middle-name' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.middleName }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.last-name' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.lastName }}</p></div>
            </div>
          }
          @if (subject.currentAddress) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.current-address' | translate }}</h3>
              <ng-container *ngTemplateOutlet='address; context:{address:subject.currentAddress}'></ng-container>
            </div>
          }
          @if (subject.inclPrevAddress) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.address.previous-address' | translate }}</h3>
              <ng-container *ngTemplateOutlet='address; context:{address:subject.prevAddress}'></ng-container>
            </div>
          }

          @if (subject.identification) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.identification' | translate }}</h3>
              @if (subject.identification.sin) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.social-insurance-number' | translate }}:</p></div>
              }
              @if (subject.identification.sin) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ maskStart(subject.identification.sin, 3) }}</p></div>
              }
              @if (subject.identification.dob) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.dob' | translate }}:</p></div>
              }
              @if (subject.identification.dob) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ maskStart(subject.identification.dob, 2) }}</p></div>
              }
              @if (subject.identification.card1) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.card1' | translate }}:</p></div>
              }
              @if (subject.identification.card1) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.identification.card1.type }}</p></div>
              }
              @if (subject.identification.card1) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.account-num' | translate }}:</p></div>
              }
              @if (subject.identification.card1) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ maskStart(subject.identification.card1.num) }}</p></div>
              }
              @if (subject.identification.card2) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.card2' | translate }}:</p></div>
              }
              @if (subject.identification.card2) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.identification.card2.type }}</p></div>
              }
              @if (subject.identification.card2) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.account-num' | translate }}:</p></div>
              }
              @if (subject.identification.card2) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ maskStart(subject.identification.card2.num) }}</p></div>
              }
              @if (subject.identification.cc) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.credit-card' | translate }}:</p></div>
              }
              @if (subject.identification.cc) {
                <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ maskStart(subject.identification.cc) }}</p></div>
              }
            </div>
          }
          @if (subject.phone) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.phone.phone' | translate }}</h3>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.number' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.phone }}</p></div>
            </div>
          }
          @if (subject.job || subject.employer) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.employment' | translate }}</h3>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.occupation' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.job }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.employer' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.employer }}</p></div>
            </div>
          }

          <!-- IDX -->

          @if (isIdxRequest) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.idx' | translate }}</h3>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.client-id' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.idx.clientId }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.email' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.idx.emailAddress }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.ip' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ subject.idx.ipAddress }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.product-type' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ this.idxProductTypes.get(subject.idx.productType) }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.interaction-type' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ this.idxInteractionTypes.get(subject.idx.interactionType) }}</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.application-channel' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ this.idxApplicationChannels.get(subject.idx.applicationChannel) }}</p></div>
            </div>
          }

          <!-- HRFA -->
          @if (subject.sin1 || subject.dob1) {
            <div>
              <h3 class="col-md-12 pt-2">{{ 'content.subject' | translate }}</h3>
            </div>
          }
          @if (subject.sin1) {
            <div class="row">
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.social-insurance-number-short' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ reformatSin(subject.sin1) }}</p></div>
            </div>
          }
          @if (subject.dob1) {
            <div class="row">
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.dob' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ reformatDate(subject.dob1) }}</p></div>
            </div>
          }
          @if (subject.sin2 || subject.dob2) {
            <div>
              <h3 class="col-md-12 pt-2">{{ 'content.joint' | translate }}</h3>
            </div>
          }
          @if (subject.sin2) {
            <div class="row">
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.social-insurance-number-short' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ reformatSin(subject.sin2) }}</p></div>
            </div>
          }
          @if (subject.dob2) {
            <div class="row">
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.person.dob' | translate }}:</p></div>
              <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ reformatDate(subject.dob2) }}</p></div>
            </div>
          }
          @if (subject.addr1) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.address.address' | translate }} 1</h3>
              <ng-container *ngTemplateOutlet='address; context:{address:subject.addr1}'></ng-container>
            </div>
          }
          @if (subject.addr2) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.address.address' | translate }} 2</h3>
              <ng-container *ngTemplateOutlet='address; context:{address:subject.addr2}'></ng-container>
            </div>
          }
          @if (subject.addr3) {
            <div class="row">
              <h3 class="col-md-12 pt-2">{{ 'content.address.address' | translate }} 3</h3>
              <ng-container *ngTemplateOutlet='address; context:{address:subject.addr3}'></ng-container>
            </div>
          }
        </ng-template>
        <ng-template #address let-address='address'>
          <!-- Explicit null check instead of truthy check to still display for hrfa addresses that have the property set to "" -->
          @if (address.type !== null) {
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.type' | translate }}:</p></div>
          }
          @if (address.type !== null) {
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ hawkTypes[address.type] || address.type }}</p></div>
          }
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.street-num' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.streetNum }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.street' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.street }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.unit-apt' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.apartmentNum }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.city' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.city }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.province' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.province }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.postal-code' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.postalCode }}</p></div>
          <!-- HRFA Address doesn't have a phone -->
          @if (address.phone) {
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.phone.phone' | translate }}:</p></div>
          }
          @if (address.phone) {
            <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ address.phone }}</p></div>
          }
        </ng-template>
        <span id="confirm-submit-modal-label" class="d-none">{{ 'aria.confirm-submit-order-dialog' | translate }}</span>
        <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons" #submitModalContainer>
          <button class="tu-button secondary tu-shadow" type="button" (click)="back()">{{ 'content.back' | translate }}</button>
          <button class="tu-button primary tu-shadow" (click)="confirmSubmit('confirm-submit-modal-label', submitModalContainer)">{{ 'content.submit' | translate }}</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </ng-template>
</app-sidenav>
